<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top :bread="pageType ? '卡项管理-'+ pageType + '次卡' : '卡项管理'"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="card-info-box">
                <el-form ref="form" :model="formData" label-width="150px" class="form" :rules="formRules">
                    <el-form-item label="卡项类别" prop="count_type">
                        <el-radio-group v-model="formData.count_type" :disabled="!isMain">
                            <el-radio label="1">次卡</el-radio>
                            <el-radio label="2">时卡</el-radio>
                            <el-radio label="3">通卡</el-radio>
                        </el-radio-group>
                        <div class="count-type-tips">
                            {{countTypeDesc}}
                        </div>
                    </el-form-item>

                    <el-form-item label="名称" prop="name">
                        <el-input v-model="formData.name" :disabled="!isMain"></el-input>
                    </el-form-item>

                    <el-form-item label="售价" prop="price">
                        <el-input v-model="formData.price" :disabled="!isMain && isUnified">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="权益" prop="product">
                        <card-select-product v-model="formData.product" :count-type="formData.count_type"
                                             add-name="点击添加项目" :disabled="!isMain" />
                    </el-form-item>

                    <el-form-item label="购卡赠送" prop="give">
                        <card-select-product v-model="formData.give" count-type="1" add-name="点击添加赠送"
                                             :disabled="!isMain"/>
                    </el-form-item>

                    <el-form-item label="有效时间" prop="valid_day">
                        <card-valid-day v-model="formData.valid_day" :disabled="!isMain" />
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">确认{{pageType}}</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                        <el-button @click="comeBack">返回</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
    import obj from "@/js/obj";
    import RightTop from "@/model/RightTop";
    import CardValidDay from "@/model/Card/CardValidDay";
    import CardSelectProduct from "@/model/Card/CardSelectProduct";
    export default {
        name: "CardEdit",
        components: {CardSelectProduct, CardValidDay, RightTop},
        props: {
            id: {
                type: [Number,String],
                default: 0
            },
        },
        data: () => ({
            selectProState: false,
            pageType: "",
            originData: {}, //原始数据
            formData: {
                count_type: "1",
                name: "",
                price: "",
                product: {},
                give: {},
                valid_day: -1
            },
            formRules: {
                count_type: [
                    {required: true, message: '请选择计次方式', trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '请输入次卡名称', trigger: 'blur'}
                ],
                price: [
                    {required: true, message: "请输入次卡售价", trigger: 'blur'},
                ],
                product: [
                    {required: true, message: "请选择权益", trigger: "blur"}
                ],
                valid_day: [
                    {required: true, message: "请设置为 1 - 9999 天", trigger: 'change'},
                    {type: "number", max: 9999, min: -1, message: "请设置为 1 - 9999 天", trigger: 'change'}
                ]
            },
            countTypeDesc: "限制次数",
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            },
            isUnified(){
                return this.$store.state.chain_option.is_unified_manage;
            }
        },
        mounted: function () {
            this.$store.commit("setMenuId", "9-1");
            this.pageType = obj.isEmpty(this.id) ? "添加" : "修改";
            this.initData();
        },
        methods: {
            initData: function () {
                if(obj.isEmpty(this.id)) {
                    this.formData = {
                        count_type: "1",
                        name: "",
                        price: "",
                        product: {},
                        give: {},
                        valid_day: -1
                    };
                }else{
                    obj.postData("card/get_card_info", {id: this.id}, res => {
                        if(res.errcode === 0){
                            let validDay = parseInt(res.data.valid_day);
                            if(validDay === 0) validDay = -1;
                            res.data.valid_day = validDay;

                            this.formData = res.data;
                            this.originData = obj.copyObject(res.data);
                        }
                    });
                }
            },
            //提交
            onSubmit: function () {
                this.$refs.form.validate( valid => {
                    if(!valid) return false;

                    if(obj.isEmpty(this.formData.product)){
                        obj.message.error("请添加项目");
                        return false;
                    }

                    if(obj.isEmpty(this.id))
                        this.addData();
                    else
                        this.setData();
                });

            },
            //修改数据
            setData: function () {
                let postData = {};
                for (let key in this.formData) {
                    let val = this.formData[key];
                    if(key === "product" || key === "give"){
                        let tmpVal = JSON.stringify(val);
                        if(tmpVal !== JSON.stringify(this.originData[key]))
                            postData[key] = tmpVal;
                    }else{
                        let tmpVal = val;
                        if(tmpVal != this.originData[key])
                            postData[key] = tmpVal;
                    }
                }

                if(obj.isEmpty(postData))
                    return false;

                postData.id = this.id;
                if(postData.valid_day == -1) postData.valid_day = "";
                obj.postData("card/set_card", postData, res => {
                    if(res.errcode === 0){
                        this.initData();
                        obj.message.success(this.pageType + "成功");
                        this.comeBack();
                    } else {
                        obj.message.error(res.errdesc);
                    }
                });
            },
            //添加数据
            addData: function () {
                let postData = {
                    count_type: this.formData.count_type,
                    name: this.formData.name,
                    price: this.formData.price,
                    product: JSON.stringify(this.formData.product),
                    give: JSON.stringify(this.formData.give),
                    valid_day: this.formData.valid_day == -1 ? "" : this.formData.valid_day,
                };

                obj.postData("card/add_card", postData, res => {
                    if(res.errcode === 0){
                        this.initData();
                        obj.message.success(this.pageType + "成功");
                        this.comeBack();
                    } else {
                        obj.message.error(res.errdesc);
                    }
                });
            },
            //返回
            comeBack: function () {
                this.$router.go(-1);
            },
        },
        watch: {
            "formData.count_type": function (val) {
                if(val === "1")
                    this.countTypeDesc = "限制次数";
                else if(val === "2")
                    this.countTypeDesc = "限制时间，如月卡、年卡等";
                else if(val === "3")
                    this.countTypeDesc = "在总次数内，可消费卡中任意一个项目";
            }
        }
    }
</script>

<style scoped>
    .card-info-box{
        background: #FFFFFF;
        padding: 16px;
    }
    .form{
        max-width: 780px;
    }
    .form .el-input{
        max-width: 300px;
    }
    .count-type-tips{
        width: 350px;
        height: 40px;
        background-color: #f5f7fa;
        color: #999999;
        padding: 0px 10px;
    }
</style>
